
import { Edit, regex, required, SimpleForm, TextInput } from "react-admin";
import { AddressInputs } from "../../components/address-inputs.component";
import { Col, Row } from "../../components/grid.component";
import { Text } from "../../components/typography.component";
import { formatCNPJ, normalizeDocumentForApi } from "../../utils/mask.util";
import { regexs } from "../../utils/regexs.util";

const Title = ({ record }: any) => <Text gutterBottom={false}>{record?.username || 'Empresa'}</Text>;

export const CompanyEdit = (props: any) => {
  return (
    <Edit
      title={<Title />}
      transform={(data: any) => ({
        ...data,
        cnpj: normalizeDocumentForApi(data.cnpj),
      })}
      {...props}
    >
      <SimpleForm>
        <Text variant="subtitle1" display="block">
          Dados básicos
        </Text>
        <Row spacing={2}>
          <Col sm={6}>
            <TextInput source="name" label="Nome" fullWidth />
          </Col>
          <Col sm={6}>
            <TextInput
              source="cnpj"
              label="CNPJ"
              fullWidth
              parse={(value: string) => value?.toUpperCase()}
              format={(value: string) => formatCNPJ(value)}
              validate={[required(), regex(regexs.CNPJ_REGEX, "CNPJ Inválido")]}
            />
          </Col>
        </Row>
        <AddressInputs />
      </SimpleForm>
    </Edit>
  );
};
